import { Component } from '@angular/core';

@Component({
  selector: 'app-disaster-manage',
  templateUrl: './disaster-manage.component.html',
  styleUrls: ['./disaster-manage.component.css']
})
export class DisasterManageComponent {
}
